import { InjectionToken } from '@angular/core';
import { GrowthBook } from '@growthbook/growthbook';
import { BehaviorSubject } from 'rxjs';
export const GROWTHBOOK = new InjectionToken<GrowthBook>('GrowthBook');

// Create a GrowthBook instance
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const gb = (expertimentViewed: BehaviorSubject<any>) => {
  return new GrowthBook({
    apiHost: 'https://cdn.growthbook.io',
    clientKey: 'sdk-eQfRi8byGUgyJ',
    // Enable easier debugging during development
    enableDevMode: false,
    // Update the instance in realtime as features change in GrowthBook
    subscribeToChanges: false,
    // Targeting attributes
    realtimeInterval: 1,
    attributes: {},
    backgroundSync: false,
    // Only required for A/B testing
    // Called every time a user is put into an experiment
    trackingCallback: (experiment, result) => {
      expertimentViewed.next({
        name: experiment.name,
        featureId: result.featureId,
        resultValue: result.value,
      });
      // analytics.expertimentViewed(experiment.key, result.key);
    },
  });
};
